<div *ngIf="showScroll" (click)="onActivate()" class="tap-top">
  <div><i class="fa fa-angle-double-up"></i></div>
</div>
<!-- <div [ngClass]="{'tap-top': showScroll}" (click)="onActivate()">
  <div><i class="fa fa-angle-double-up"></i></div>
</div> -->
